/*
write by wuweiwei
www.cnblogs.com/wsoft
*/

var wPlaceHolder = function(options){
    /*
    options = {
        display:"none|block",
        el:DOM,  必选
        input:input DOM 必选
        text:"", 必选
        normalWidth:"20px",
        tran:["",""], 两个组合起来==text,tran数组是为了语言中查找 必选
        offsetX:x, //x is string 在元素内的相对偏移量
        offsetY:y, //y is string
        fixedPosition:{
            offsetX:""
            offsetY:""
        }
        style:{
        key:value
        },
        class:""
    }
    */
    let offsetX,offsetY;
    this.isFocus = false;
    this.options = options;
    this.offsetX = options.offsetX ? options.offsetX : "0";
    this.offsetY = options.offsetY ? options.offsetY : "0";
    this.tipNode = document.createElement("div");
    this.tipNode.style.display = options.display ? options.display : "block";
    this.tipNode.innerText = this.options.text;
    this.tranText = this.options.tranText || this.options.text;
    this.tipNode.setAttribute("language","yes");
    this.tipNode.style.position = "absolute";
    this.xDiff = 0; // 页面app元素的水平滚动条滚动距离
    if(!!options.normalWidth)
    {
        this.tipNode.style.width = options.normalWidth;
        this.tipNode.style.overflow = "hidden";
        this.tipNode.style.textOverflow = "ellipsis";
        this.tipNode.style.whiteSpace = "nowrap";
    }
    if(!!this.options.fixedPosition)
    {
        this.options.fixedPosition.offsetX = this.options.fixedPosition.offsetX ? this.options.fixedPosition.offsetX :"0";
        this.options.fixedPosition.offsetY = this.options.fixedPosition.offsetY ? this.options.fixedPosition.offsetY :"0";
    }
    this.bbox = {};
    this.options.el.appendChild(this.tipNode);
    this.tipNode.style.left = this.offsetX;
    this.tipNode.style.top = this.offsetY ;
    this.tipNode.className = options.class ? options.class : "wPlaceHolder";
    this.className = options.class ? options.class : "wPlaceHolder";
    this.tipNode.style.pointerEvents = "none";
    wPlaceHolder.component.objects.push(this);
    this.initPosition(this.options.input, true);
    this.bindEvent();
}

wPlaceHolder.prototype.initPosition = function(currentInput, isFirst) { 
    let bbox;
    let th = this;
    bbox = (currentInput.getBoundingClientRect());
    document.getElementsByTagName("body")[0].appendChild(this.tipNode);
    this.tipNode.style.position = "absolute";
    this.tipNode.style.zIndex = 99;
    this.tipNode.style.left = (bbox.left + window.scrollX + parseInt(this.options.fixedPosition.offsetX) + th.xDiff) + "px";
    this.tipNode.style.top = (bbox.top + window.scrollY + parseInt(this.options.fixedPosition.offsetY)) + "px";
    if(!!isFirst)
    {
        this.tipNode.style.width = this.options.normalWidth;
    }
    else
    {
        this.tipNode.style.width = "";
    }
} 
wPlaceHolder.prototype.show = function(){
    this.tipNode.style.display = "block";
}
wPlaceHolder.prototype.hide = function(){
    this.tipNode.style.display = "none";
}

wPlaceHolder.prototype.bindEvent = function(){
    let input = this.options.input;
    let th = this;
    input.onfocus = function(e){
        th.initPosition(this);
        th.isFocus = true;
        th.tipNode.className = th.className + " wPlaceHolderFocus";
    }
    input.onblur = function(e){
        th.isFocus = false;
        th.tipNode.className = th.className;
        th.tipNode.style.width = th.options.normalWidth;
    }
    input.oninput = function(e){
        
        if(this.value=="")
        {
            th.tipNode.style.display = "block";
        }
        else
        {
            th.tipNode.style.display = "none";
        }
    }
    this.onresize = function(){
        th.initPosition(th.options.input, !th.isFocus);
    }

    window.addEventListener("resize",this.onresize,false);

    try
    {
        document.getElementById("app").addEventListener("scroll",function(){
            this.xDiff = this.scrollLeft;
            th.initPosition(th.options.input, false);
        },false);
    }
    catch(e){}


}
wPlaceHolder.prototype.dispose = function(){
    window.removeEventListener("resize", this.onresize);
    this.options.input.onblur = null;
    this.options.input.onfocus = null;
    this.options.input.oninput = null;
    let objects = wPlaceHolder.component.objects;
    let len = objects.length;
    let _this = this;
    this.tipNode.parentNode.removeChild(this.tipNode);
    let i;
    for(i=0;i<len;i++)
    {
        if(objects[i] == this)
        break;
    }
    objects.splice(i,1);
    
    _this = null;
}

wPlaceHolder.dispose = function(){
    let objects = wPlaceHolder.component.objects;
    window.removeEventListener("resize", this.onresize);
    objects.forEach( (item)=>{
        item.options.input.onblur = null;
        item.options.input.onfocus = null;
        item.options.input.oninput = null;
        item.tipNode.parentNode.removeChild(item.tipNode);
        item = null;
    });
    wPlaceHolder.component.objects.length = 0;
};

wPlaceHolder.component = {
    objects:[]
}

wPlaceHolder.locale = function(options){
    /*
    options={
        el:{},
        msg:{
            "中文":"其他语言",
            "升级":"Upgrade"
        }
    }
    */
    wPlaceHolder.component.objects.forEach( (item) =>{
        let key1,key2,v1,v2,text;
        if(!!item.options.tran)
        {
            key1 = item.options.tran[0];
            key2 = item.options.tran[1];
            v1 = options.msg[key1];
            v2 = options.msg[key2];
            text = v1.replace("{param}",v2);
        }
        else
        {
            text = options.msg[item.tranText];
        }
        
        item.tipNode.innerText = text;
    });
}
export {wPlaceHolder}



